import { IconButton } from "@mui/material";
import useColors from "../api/hooks/useColors";
import SvgToIcon from "../icons/SvgToIcon";
import { icons } from "../scenes/stack/environment/icons/iconExport";
import CustomToolTip from "./CustomTooltip";
import LoadingIcon from "./LoadingIcon";

const FavoritesButton = ({
  handleToggleFavorite,
  isFavorite,
  isLoading,
  sx = {},
}) => {
  const colors = useColors();

  return (
    <CustomToolTip
      title={isFavorite ? "Remove from favorites" : "Add to favorites"}
      placement="top"
    >
      <IconButton
        onClick={handleToggleFavorite}
        disabled={isLoading}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: colors.common_white,
          height: "32px",
          width: "32px",
          border: "1px solid " + colors.enabled_stroke,

          borderRadius: "8px",
          textTransform: "none",
          whiteSpace: "nowrap",
          ...sx,
          "&:hover": {
            background: colors.grey_8percent,
          },
        }}
      >
        {isLoading ? (
          <LoadingIcon size={16} />
        ) : (
          <SvgToIcon
            IconLogo={icons.favoritesIcon}
            width="18px"
            height="18px"
            style={{
              color: isFavorite
                ? colors.warning_yellow_300_main_yellow
                : colors.grey_500,
              width: "18px",
              height: "18px",
            }}
          />
        )}
      </IconButton>
    </CustomToolTip>
  );
};

export default FavoritesButton;
